export default __webpack_public_path__ + "static/media/MyriadPro-Light.43b72dcd.woff";